<template>
  <div class="market-status-isLeveraged">
    <div class="trade-status">
      <span>{{ marketStatusText }} </span>
    </div>
    <div v-if="showMargin" class="margin-content">
      <span>{{ $t('trade.margin') }}</span>
      <span>{{ marginText }}</span>
    </div>
  </div>
</template>

<script>
import { SEC_TYPE } from 'const/stock'
import { mapGetters } from 'vuex'
export default {
  name: 'TradeStatus',
  computed: {
    ...mapGetters(['isMargin', 'isIb', 'tradeRequest', 'asset']),
    stock() {
      return this.tradeRequest.stock
    },
    contract() {
      return this.tradeRequest.contract
    },
    marketStatusText() {
      return this.stock.marketStatus
    },
    isOPT() {
      return this.stock.secType === SEC_TYPE.OPT
    },
    marginText() {
      const percent = this.$options.filters.percent
      const marginTextArr = []
      if (this.contract && this.contract.longInitialMargin) {
        const logonMargin = percent(this.contract.longInitialMargin)
        marginTextArr.push(`${logonMargin}(${this.$t('trade.long-trade')})`)
      }
      if (this.contract && this.contract.shortInitialMargin) {
        const shortMargin = percent(this.contract.shortInitialMargin)
        marginTextArr.push(`${shortMargin}(${this.$t('trade.short-trade')})`)
      }
      return marginTextArr.join(' / ')
    },
    showMargin() {
      return (
        !this.isOPT &&
        this.isMargin &&
        this.contract &&
        (this.contract.longInitialMargin > 0 ||
          this.contract.shortInitialMargin > 0)
      )
    }
  }
}
</script>

<style lang="less" scoped>
@import '~uikit';
.market-status-isLeveraged {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  margin: 0 10px 10px;
  .trade-status {
    display: flex;
    flex: 1;
    justify-content: space-between;
    flex-shrink: 0;
    color: #838d9e;
    .tips {
      font-size: 12px;
      font-weight: 600;
      color: var(--active-color);
    }
  }
  .margin-content {
    flex: 1;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;
    color: #838d9e;
  }
}
</style>
